module.exports = {
  url: "http://127.0.0.1:4200",
  options: {}
};
